module.exports = __webpack_public_path__ + "media/assets/images/log_in-01cf63564fd6c6c08f9ca79384ce58ce.jpg";